import * as React from 'react'
import * as Styled from './Column.styles'

const Column = ({
  children,
  backgroundColor = 'none',
  borderColor = 'none',
  borderType = 'none',
  image = null,
  svg = null,
  listIcon = null,
  heading = null,
  subheading = null,
  ...props
}) => {
  const { aspectRatio, borderRadius, customPosition } = props || {}
  return (
    <Styled.Column
      className="leshen-column-wrapper"
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      borderType={borderType}
      svg={svg}
      listIcon={listIcon}
      aspectRatio={aspectRatio}
      borderRadius={borderRadius}
      customPosition={customPosition}
      {...props}
    >
      {image}
      {heading && heading}
      {subheading && subheading}
      <div className="content">{children}</div>
    </Styled.Column>
  )
}

export default Column
